// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"189e022c","453":"0694d0f4"}[chunkId] + ".chunk.js";
};